import React, { useState } from "react";
import {
  formatDecimalHour,
  formatDuration,
  formatDurationToHourMin,
  formatFrenchDate,
  formatMinutesToHourMinute,
  lieuIntervention,
} from "../utils/utils";
import { useDispatch } from "react-redux";
import { handleAcceptationRdv } from "./rdvoffcanvas/AcceptationRdv";
import { RefusRdv } from "./rdvoffcanvas/RefusRdv";
import Popup from "./Popup";
import { useNavigate } from "react-router-dom";

function CardRdv({ rdvDetails, borderNone = null }) {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const locationIcons = lieuIntervention();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log("rdvDetails", rdvDetails);
  const handlePopupAction = () => {
    RefusRdv({ dispatch, rendezVous: rdvDetails, setPopupVisible });
  };
  return (
    <>
      <div className="col-12 col-sm-12 col-lg-6 mt-16">
        <div className={`frame-demande ${borderNone ? "borderNone" : ""}`}>
          <div className="d-flex justify-content-between align-items-start mb-16">
            <div>
              <h5 className="mrb-4">
                {" "}
                {formatFrenchDate(rdvDetails?.start_time)}
              </h5>
              <p className="body">
                {" "}
                {new Date(rdvDetails?.start_time).toLocaleTimeString("fr-FR", {
                  hour: "2-digit",
                  minute: "2-digit",
                  // timeZone: "Europe/Paris",
                })}
                <img
                  className="separator"
                  src="/images/separateur.svg"
                  alt="separateur"
                />
                {formatDecimalHour(rdvDetails?.duration_hours)}
              </p>
            </div>
            <img
              src={locationIcons[rdvDetails?.lieu_intervention]}
              alt={rdvDetails?.lieu_intervention}
            />
          </div>
          {rdvDetails?.equipe_auto_assigned == false ? (
            <p className="body bold500 mb-8">
              Préférence de l’employé :{" "}
              <span className="body grey66">{rdvDetails?.equipe?.name}</span>
            </p>
          ) : (
            <></>
          )}
          <p className="body bold500 mb-8">
            {rdvDetails?.prestations_snapshot?.map((p) => p.name).join(", ")}
          </p>

          <div className="d-flex justify-content-between"></div>
          {/* {rdvDetails?.prestations_snapshot?.map((prestation, index) => ( */}
          <div className="d-flex justify-content-between align-items-center test">
            <div>
              <img
                className="mr-8"
                src="/images/user-profile-gray.svg"
                alt="user-profile"
              />
              <span className="body grey-light">
                {rdvDetails?.user?.nom} {rdvDetails?.user?.prenom}
              </span>
              <img
                className="separator"
                src="/images/separateur.svg"
                alt="separateur"
              />
              {rdvDetails?.status == "enattente" ? (
                <>
                  <img className="mr-8" src="/images/time.svg" alt="time" />
                  <span className="body grey-light">
                    {formatMinutesToHourMinute(
                      rdvDetails?.prestations_snapshot[0]?.duree
                    )}
                    , {rdvDetails?.prestations_snapshot[0]?.nbr_seances}{" "}
                    rendez-vous
                  </span>
                </>
              ) : (
                <>
                  {rdvDetails?.user?.phone_number && (
                    <span className="body grey-light">
                      <img
                        src="/images/tel.svg"
                        alt="Téléphone"
                        className="me-2"
                      />
                      {rdvDetails?.user?.phone_number}
                    </span>
                  )}
                </>
              )}
            </div>
            {rdvDetails?.status !== "enattente" && (
              <img
                src="/images/fleche-blue.svg"
                alt="voir"
                onClick={() =>
                  navigate(`/compte/rendez-vous/${rdvDetails?.id}`)
                }
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
          {/* ))} */}
          {rdvDetails?.status == "enattente" && (
            <div className="row mt-28">
              <button
                className="col twyny-cta-secondary mr-16"
                onClick={() => {
                  setPopupVisible(true);
                }}
              >
                {" "}
                Refuser
              </button>
              <button
                className="col twyny-cta-primary mr-16"
                onClick={() =>
                  handleAcceptationRdv(dispatch, rdvDetails, null, true)
                }
              >
                {" "}
                Accepter
              </button>
            </div>
          )}
        </div>
      </div>
      {isPopupVisible && (
        <Popup
          isOpen={isPopupVisible}
          onClose={() => {
            setPopupVisible(false);
          }}
          onAction={() => handlePopupAction()}
          title={
            "Attention, vous allez refuser un rendez-vous. Êtes-vous sûr de vouloir poursuivre ?"
          }
          text={
            <p className="body">
              Vous ne pourrez plus voir ou accepter cette demande.
            </p>
          }
          actionButtonText={"Refuser le rendez-vous"}
          closeButtonText="Annuler"
          closeButtonClassName="bold600"
          color="red"
          icon={
            <svg
              width="88"
              height="88"
              viewBox="0 0 88 88"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="88"
                height="88"
                rx="14.6667"
                fill="#DD1E03"
                fillOpacity="0.1"
              />
              <path
                d="M44.4001 44.4001V34.5001M44.4001 51.7381V51.8251M64.2001 44.4001C64.2001 55.3353 55.3353 64.2001 44.4001 64.2001C33.4649 64.2001 24.6001 55.3353 24.6001 44.4001C24.6001 33.4649 33.4649 24.6001 44.4001 24.6001C55.3353 24.6001 64.2001 33.4649 64.2001 44.4001Z"
                stroke="#DD1E03"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        />
      )}
    </>
  );
}

export default CardRdv;
